import { Card, Flex, Heading } from "@amzn/storm-ui";
import styled from "styled-components";

export const StyledErrorBoundaryContainer = styled(Flex)`
    height: 100vh;
    text-align: center;
`;

export const StyledErrorBoundaryCard = styled(Card)`
    display: flex;
    flex-direction: column;
    height: max-content;
    padding: 24px;
    width: 50vw;
    min-width: max-content;
    margin-top: 48px;
`;

export const StyledErrorBoundaryText = styled(Heading)`
    margin-bottom: 16px;
`;
